import heroBg from "./assets/hero-bg.jpg";

const Hero = () => {
  return (
    <section
      className="hero"
      id="home"
      style={{
        backgroundImage: `
          linear-gradient(
            rgba(15, 76, 129, 0.8),
            rgba(8, 52, 90, 0.5)
          ),
          url(${heroBg})
        `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container">
        <h1>
          Trusted Eye Care & Stylish Watches <br />
          <span>in Masrakh, Bihar</span>
        </h1>

        <p>
          Accurate eye check-up • Branded lenses • Affordable spectacles <br />
          Premium & budget watches for all ages
        </p>

        <div className="cta-group">
          <a href="tel:9546525492" className="btn primary">
            📞 Book Eye Check-Up <br />
            <strong>for FREE</strong>
          </a>

          <a
            href="https://wa.me/919546525492"
            target="_blank"
            rel="noreferrer"
            className="btn secondary"
          >
            💬 Ask on WhatsApp
          </a>

          <a
            href="https://maps.app.goo.gl/3iFSGFmevvruELR36"
            target="_blank"
            rel="noreferrer"
            className="btn secondary"
          >
            📍 Visit Store
          </a>
        </div>

        <p className="trust-line">
          ✔ Trusted by Masrakh families for eye care & watches
        </p>
      </div>
    </section>
  );
};

export default Hero;
